import axios from 'axios';
import { HttpWebtrack } from 'utility/http';
import { ConfigActions } from '../../../../utility/http/http-events';
import configureInterceptors from 'utility/http/interceptors/configure-interceptors';
import { store } from '@redux/storeConfig/store';
import { ActivityLogEntry } from '../types';
import API_BASE_URL from '@redux/sagas/settings/apibaseurl';

const baseUrl = '/activity';

export const createSessionService = (
  request: { platform: string; apiKeyId?: number },
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/sessions/create`, request);
};

export const closeSessionService = (
  request: { sessionId: string; status?: string },
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/sessions/close`, request);
};

// Anonymous endpoint for closing sessions on logout (token already cleared).
// Uses fetch with keepalive to guarantee delivery even if the page navigates away.
// NOTE: sendBeacon doesn't work cross-origin with application/json (no CORS preflight support).
export const endSessionService = (request: { sessionId: string; status?: string }) => {
  fetch(`${API_BASE_URL}/Activity/sessions/end`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
    keepalive: true
  });
};

export const batchInsertLogsService = (
  request: { sessionId: string; logs: ActivityLogEntry[] },
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/logs/batch`, request);
};

export const getActivityLogsService = (
  request: {
    userId?: number;
    fromDate?: string;
    toDate?: string;
    actionType?: string;
    pageNumber?: number;
    pageSize?: number;
  },
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/logs/get`, request);
};
